let reviews = document.querySelector('.product-ingo__reviews');

if (reviews) {
    reviews.addEventListener('click', function (event) {
        document.querySelector('.shopify-app-block #stamped-main-widget').scrollIntoView({ behavior: 'smooth' });
    });
}


setTimeout(() => {
    const reviewsContainer = document.querySelector(".product-info__accordion-reviews");
    const reviewsBadge = document.querySelector(".stamped-badge-caption");

    const noReviewsInBadge = reviewsContainer && reviewsBadge && reviewsBadge.getAttribute('data-reviews') === '0';

    if (noReviewsInBadge) {
        const accordion = document.querySelector(".product-info__accordion-reviews");
        if (accordion) {
            accordion.classList.add("product-info__accordion-reviews--hidden");
        }
    }
  }, "1500");
